import React from 'react';
import { Heading, Stack, Text } from '@origin-digital/ods-core';

export const GreenOptionModal = (
  <Stack space="xlarge">
    <Heading variant="h3">100% GreenPower electricity</Heading>
    <Text>
      Origin will source electricity from GreenPower accredited renewable sources to match 100% of
      your electricity usage. This means that for 100% of electricity you consume, the equivalent
      amount of renewable energy gets sent to the grid.
    </Text>
  </Stack>
);
